module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title",
    attrs: {
      "id": "Illustrations"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Foreword#fig_1"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("1.")]), _vm._v(" Model of original Atatürk Concert Hall and Exhibition Center, Taksim Square, Istanbul")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_2"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("2.")]), _vm._v(" May 10 1933. Berlin book burnings")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_3"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("3.")]), _vm._v(" Beyazit Portal to Istanbul University, circa 1933")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_4"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("4.")]), _vm._v(" Dr. Philipp Schwarz. Courtesy, Archives-Verein Museum, Berlin and son Andrew Schwarz, Acton, MA")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_5"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("5.")]), _vm._v(" Letter to the U. S. Secretary of State from American Ambassador in Istanbul on November 10 1933")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_6"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("6.")]), _vm._v(" Letter continued")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#fig_7"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("7.")]), _vm._v(" Outside of Ankara. A typical Sunday excursion. This one combined the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reuter, Merzbacher, Eckstein,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gerngross")]), _vm._v(" families. Courtesy Dr. Eugen Merzbacher, Chapel Hill, NC")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_8"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("8.")]), _vm._v(" Blue Mosque (Sultanahmet Camii), Istanbul, Turkey. Built between 1609 and 1616 by Mehmet Aga, the imperial architect, for Sultan Ahmet I")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_9"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("9.")]), _vm._v(" Within the Blue Mosque")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_10"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("10.")]), _vm._v(" Margarete Schütte-Lihotzky. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_11"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("11.")]), _vm._v(" According to Schütte-Lihotzky, badly located kitchen cabinetry on the left and design with efficiently located cabinetry on the right")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_12"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("12.")]), _vm._v(" Schütte-Lihotzky’s Frankfurt Kitchen: Plan and elevations.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_13"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("13.")]), _vm._v(" Schütte-Lihotzky’s Frankfurt Kitchen: Isometric")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_14"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("14.")]), _vm._v(" Clemens Holzmeister. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_15"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("15.")]), _vm._v(" Headquarters of Turkish Armed Forces General Staff, Ankara")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_16"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("16.")]), _vm._v(" Presidential Residence. Atatürk personally invited Holzmeister to design Turkey’s first Presidential residence")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_17"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("17.")]), _vm._v(" The Central Bank, Ankara")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_18"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("18.")]), _vm._v(" Bruno Taut. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_19"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("19.")]), _vm._v(" Taut’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glasspavillion,")]), _vm._v(" Cologne")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_20"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("20.")]), _vm._v(" Fountain of Sultan Abdülhamid I")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#fig_21"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("21.")]), _vm._v(" Entrance to the Dolmabahce Palace. Photo by Dick Osseman, Amsterdam, Holland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_22"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("22.")]), _vm._v(" Istanbul Archeological Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_23"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("23.")]), _vm._v(" Georg Rohde (1899-1960). Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_24"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("24.")]), _vm._v(" Manyas Lake. Photo by Suzanne Leroy, Uxbridge, UK")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_25"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("25.")]), _vm._v(" Bald ibis")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig_26"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("26.")]), _vm._v(" September 14 1937. Letter from Faculty of Medicine Dean to the university’s Rector calling a faculty committee meeting to choose Professor Neville’s replacement. Kosswig is recommended. University of Istanbul Personnel Archives")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("27.")]), _vm._v(" Ernst Praetorius. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("28.")]), _vm._v(" President’s Philharmonic Orchestra in Ankara, 1996")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("29.")]), _vm._v(" 1944 playbill from a Carl Ebert-directed opera. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("30.")]), _vm._v(" A Carl Ebert Production of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Madame Butterfly,")]), _vm._v(" Ankara, 1942. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("31.")]), _vm._v(" Presidency’s Symphonic Orchestra (CSO)")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("32.")]), _vm._v(" Amar Quartet")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("33.")]), _vm._v(" Eduard Zuckmayer. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("34.")]), _vm._v(" Zuckmayer’s Turkish translation of a German folk song, “True friendship shall not waver.” Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("35.")]), _vm._v(" Painting in watercolors by Architect C. Holzmeister. Chapel of St. Barbara in Göreme, Turkey")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#fig_36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("36.")]), _vm._v(" Village de Poivres. Leopold Levy, courtesy Fine Arts Museum of San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#fig_37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("37.")]), _vm._v(" Ernst Reuter. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#fig_38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("38.")]), _vm._v(" Ernst Reuter surrounded by some of his students in Ankara. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#fig_39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("39.")]), _vm._v(" Alexander Rüstow, 1945. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#fig_40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("40.")]), _vm._v(" Gerard Kessler")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#fig_41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("41.")]), _vm._v(" Umberto Ricci. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#fig_42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("42.")]), _vm._v(" Fritz Neumark, 1945. Courtesy Mattias Neumark")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#fig_43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("43.")]), _vm._v(" Hikmet Küney, 1945. Courtesy Küney family, Istanbul")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#fig_44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("44.")]), _vm._v(" Ernst E. Hirsch. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("45.")]), _vm._v(" “Saglik boyle korunmalidir.” “Health should be protected like this.” A cartoon of Julius Hirsch. Istanbul University’s Medical School student New Year’s spoof")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("46.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction to Tumor Science")]), _vm._v(" by Philipp Schwarz. 1950 Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("47.")]), _vm._v(" Wilhelm Liepmann. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("48.")]), _vm._v(" Dr. Frank’s gravestone. Phot by Dr. Arin Namal, Istanbul")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("49.")]), _vm._v(" Title and byline of a Steinitz paper written in Istanbul and published in America. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Clinical")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Investigation")]), _vm._v(", Vol 19 (2), 1940, (299-305)")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("50.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clinic Laboratory Procedures")]), _vm._v(" by Kurt Steinitz with a foreword by Alfred Erich Frank, 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("51.")]), _vm._v(" File copy of Steintz’s 1934 Turkish Identity Card. University of Istanbul Personnel Archives")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("52.")]), _vm._v(" A child with Noma")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("53.")]), _vm._v(" 1947 Turkish medical journal cover with a contribution by Dr. Eckstein")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("54.")]), _vm._v(" “I congratulate the country for the low death rate of its nursing infants.” —Dr. [Albert] Eckstein")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("55.")]), _vm._v(" Turkish 10 Lira banknote issued in 1942 using a 1935 Eckstein photo of village women")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("56.")]), _vm._v(" Photograph taken by Prof. Eckstein in Bürmük Village/ Bolu, which was printed on the 10 Turkish Lira banknote in 1942. Courtesy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Goethe")]), _vm._v(" Institute, Istanbul")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("57.")]), _vm._v(" A photograph that was displayed at the Turkish Pavilion of the World Fair in New York in 1939. Courtesy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Goethe")]), _vm._v(" Institute, Istanbul")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("58.")]), _vm._v(" Eckstein’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Problems of Population Policy and Public Health and Their Investigation from the Perspective of the")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pediatrician’s Duties")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("59.")]), _vm._v(" Ord. Prof. Albert Eckstein. Courtesy, Klaus Eckstein, Cambridge, UK")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("60.")]), _vm._v(" Drs. Albert and Erna Eckstein and their Turkish coworkers, 1949. Courtesy, Klaus Eckstein, Cambridge, UK")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("61.")]), _vm._v(" “To our beloved teacher.” A 1937 photograph of Dr. Hellmann and his ENT residents. Courtesy, Miriam (Hellmann) Schmidt, Hod Hasharon, Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("62.")]), _vm._v(" Dr. Hellmann and his former ENT residents. Some are wearing military uniforms. Courtesy, Miriam (Hellmann) Schmidt, Hod Hasharon, Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("63.")]), _vm._v(" Joseph Igersheimer. Courtesy, Dr. Walter Igersheimer, Corvallis, OR")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("64.")]), _vm._v(" Examination room in Igersheimer’s Eye Clinic. 1938 Faculty of Medicine Alumni Yearbook")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("65.")]), _vm._v(" Igersheimer as depicted by his students in their 1935 yearbook")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("66.")]), _vm._v(" Front cover of Igersheimer Turkish textbook "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eye")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("diseases")]), _vm._v(", with Dr. Murad Rami Aydin as translator")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("67.")]), _vm._v(" Igersheimer and some of his post graduate students, residents, and clinical assistants. Faculty of Medicine 1938 Yearbook")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("68.")]), _vm._v(" Page 1 from Dr. Igersheimer’s bibliography accompanying his 1939 job application to the medical school at Tufts University. Courtesy, Dr. Walter Igersheimer, Corvallis, OR and Tufts University Archives")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("69.")]), _vm._v(" Page 2 from Dr. Igersheimer’s bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("70.")]), _vm._v(" OTO opthalmology. Jozef Igersheimer & G. Malouf, “Eye signs in head injuries”")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("71.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Indications in Surgery,")]), _vm._v(" Nissen Textbook, 1938")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("72.")]), _vm._v(" Professor Rudolph Nissen and some of his surgical residents")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("73.")]), _vm._v(" Eduard Melchior. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("74.")]), _vm._v(" Professor Melchior and some of the Turkish surgeons he had trained, 1953. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07a#fig_75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("75.")]), _vm._v(" Reza Shah with Kemal Atatürk on his official visit to Turkey in 1934. Archival photo")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("76.")]), _vm._v(" Erwin Finlay Freundlich. Courtesy, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("77.")]), _vm._v(" Some of the problems encountered by E. Finlay Freundlich in procuring Turkey’s first telescopic instrument")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("78.")]), _vm._v(" Continues from previous page. Courtesy, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("79.")]), _vm._v(" Yale’s astronomers’ contributions of publications for the Istanbul observatory’ library. Courtesy, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("80.")]), _vm._v(" Wolfgang Gleisberg, 1970. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_81",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("81.")]), _vm._v(" Chemistry Professor Fritz Arndt, courtesy Dr. Lale Burk, Chemistry Department, Smith College")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("82.")]), _vm._v(" 83. Some examples of the tangible and long-lasting contributions that Fritz Arndt made to science education in Turkey")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_84",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("84.")]), _vm._v(" 85. Continued")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_86",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("86.")]), _vm._v(" 87. Continued")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("88.")]), _vm._v(" Professor Fritz Arndt and some of his Turkish graduate students. Courtesy, Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_89",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("89.")]), _vm._v(" Chemistry Professor Arndt and more of his former Turkish graduate students. Courtesy Archives-Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_90",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("90.")]), _vm._v(" Letter from Felix Haurowitz to Linus Pauling. Their professional correspondence preceded Pauling’s Nobel award by two decades. Courtesy, Linus Pauling Ar chives, Oregon State University, Corvallis, OR")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_91",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("91.")]), _vm._v(" Haurowitz biochemistry textbook, 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_92",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("92.")]), _vm._v(" Dr Felix Haurowitz with his Turkish laboratory co-workers. Circa 1940s. Courtesy, Dr. Alice (Haurowitz) Sievert, Lake Bluff, IL")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_93",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("93.")]), _vm._v(" Ernst W. Caspari. Courtesy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Molecular Genetics of")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Development")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_93a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("93a.")]), _vm._v(" Caspari’s father in Lodz ghetto. Courtesy, The Jewish Heritage Writing Project")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_94",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("94.")]), _vm._v(" Werner Lipschitz. Courtesy, Istanbul University Archives")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("95.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Textbook of Biomedical Chemistry,")]), _vm._v(" Lipschitz, 1937")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("96.")]), _vm._v(" Winterstein Physiology Text, 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_97",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("97.")]), _vm._v(" Winterstein Animal Physiology Text, 1946")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_98",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("98.")]), _vm._v(" A cartoon of Winterstein, Haurowitz, and othertextbook authors. 1945 Student New Year’s spoof. Istanbul University Medical School")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("99.")]), _vm._v(" Reiningers, Walter, Margaret, daughter Eva Ruth. Courtesy, Istanbul University Archives")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_100",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("100.")]), _vm._v(" Letter from von Mises to Albert Einstein, December 10, 1919. Courtesy, Harvard University Archives and Magda (Geiringer-V. Mises) Tisza")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_101",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("101.")]), _vm._v(" Letter continued")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_102",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("102.")]), _vm._v(" Letter from von Mises to Albert Einstein, November 29, 1919. Courtesy, Harvard University Archives and Magda (Geiringer-V. Mises) Tisza")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("103.")]), _vm._v(" Letter continued")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_104",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("104.")]), _vm._v(" 105. Richard von Mises. Courtesy St Andrews University, Scotland.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_106",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("106.")]), _vm._v(" 107. Hilda Geiringer. Courtesy, Magda (Geiringer-V. Mises) Tisza")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_108",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("108.")]), _vm._v(" Page 3 of “Scientific Publications of Prof. Dr. Ing. Willy Prager, Istanbul.” June 28 1939. Courtesy, Institute for Advanced Studies, Princeton")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("109.")]), _vm._v(" Von Hippel and assistant giving a lecture- demonstration in Jena (1927)")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("110.")]), _vm._v(" Von Hippel’s laboratory servant at Istanbul University")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("111.")]), _vm._v(" Hans Reichenbach. Courtesy, Elisabeth (Reichenbach), Austin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08a#fig_112",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("112.")]), _vm._v(" A handwritten note from Albert Einstein to Hans Reichenbach April 8 1926. Courtesy, Einstein Archives, Hebrew University of Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09a#fig_113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("113.")]), _vm._v(" Memorandum regarding German-Jewish professors in the University of Istanbul")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09a#fig_114",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("114.")]), _vm._v(" Lilli Merzbacher’s denaturalization notice. Courtesy, Dr. Eugen Merzbacher, Chapel Hill, NC")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09a#fig_115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("115.")]), _vm._v(" Morgenthau’s letter to Freundlich. Courtesy, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09a#fig_116",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("116.")]), _vm._v(" Shapley’s letter to Freundlich")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09a#fig_117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("117.")]), _vm._v(" Letter continues. Courtesy, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_118",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("118.")]), _vm._v(" Einstein letter to Reichenbach about anti-Semitic hiring practices at Princeton University, May 2, 1936. Courtesy, Einstein Archives, Hebrew University of Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_119",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("119.")]), _vm._v(" Kantorowicz announces acceptance of position offered. American Council for Emigres in the professions, M. E. Grenander Department of Special Collections and Archives, University at Albany Libraries")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_120",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("120.")]), _vm._v(" Kantorowicz’s letter of 23 October, 1941. American Council for Emigres in the professions, M. E. Grenander Department of Special Collections and Archives, University at Albany Libraries 334")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_121",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("121.")]), _vm._v(" John Dewey’s letter of support for Kantorowicz. American Council for Emigres in the professions, M. E. Grenander Department of Special Collections and Archives, University at Albany Libraries 335")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_122",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("122.")]), _vm._v(" Letter to University of Chicago President in support of astronomer Hans Rosenberg. The entire set of correspondence involving Hans Rosenberg is courtesy of the Special Collection Department, The University of Chicago Library")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("123.")]), _vm._v(" Letter continued")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("124.")]), _vm._v(" Memo to President Hutchins regarding H. Rosenberg’s salary subvention")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_125",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("125.")]), _vm._v(" Salary subvention from Chicago’s Jewish community")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_126",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("126.")]), _vm._v(" Salary subvention from Chicago’s Jewish alumnae")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_127",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("127.")]), _vm._v(" Third party’s go-between Rosenberg in Germany and the University of Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_128",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("128.")]), _vm._v(" Letter continued")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("129.")]), _vm._v(" Struve’s cover letter to UC’s Development Committee regarding Rosenberg")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_130",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("130.")]), _vm._v(" Letter of support for Karl Strupp from the Greek Ambassador to France. The entire set of correspondence involving Karl Strupp is courtesy ofAmerican Council for Emigres in the professions, M. E. Grenander Department of Special Collections and Archives, University at Albany Libraries")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_131",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("131.")]), _vm._v(" Letter of support for Karl Strupp from the Director General of the Pan American Health Union")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_132",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("132.")]), _vm._v(" Letter of support for Karl Strupp from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fortune")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Magazine")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#fig_133",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("133.")]), _vm._v(" Letter regarding “no jobs” for Karl Strupp")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#fig_134",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("134.")]), _vm._v(" Ernst Geiringer’s letter to Einstein, May 2 1933. Courtesy, Einstein Archives, Hebrew University of Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#fig_135",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("135.")]), _vm._v(" A letter to Freundlich from Barrister Samuels. Courtesy, E. Finlay Freundlich Archives, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#fig_136",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("136.")]), _vm._v(" August 21 1934 letter to physicist Max von Laue from his professional “colleague” and fellow Nobel laureate, Johannes Stark. Courtesy, E. Finlay Freundlich Archives, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#fig_137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("137.")]), _vm._v(" September 1 1934, reply letter from Max von Laue to Johannes Stark. Courtesy, E. Finlay Freundlich Archives, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#fig_138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("138.")]), _vm._v(" Draft of Einstein’s famous “Great Spirits” quotation. Courtesy, Einstein Archives, Hebrew University of Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#fig_139",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("139.")]), _vm._v(" Response from the Home Office to Barrister Samuels regarding Finlay Freundlich’s attempt to re-emigrate to Britain. Courtesy, E. Finlay Freundlich Archives, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#fig_140",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("140.")]), _vm._v(" A January 24 1937 communication to Freundlich in Prague from the UK-based Academic Assistance Council. Courtesy, E. Finlay Freundlich Archives, St Andrews University, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#fig_141",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("141.")]), _vm._v(" Felix Haurowitz: A great man and a battered selfesteem. Courtesy, Alice (Haurowitz) Sievert")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13a#fig_142",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("142.")]), _vm._v(" Klaus and Peter Eckstein, 1940. Courtesy, Archives- Verein Museum, Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#fig_143",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("143.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Time of the Émigrés. Le Journal d’Orient,")]), _vm._v(" October 30, 1933. “L’université ouvre le 5 Novembre”")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Appendix3#fig_144",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("144.")]), _vm._v(" Turkey’s Comparative Global Competitiveness Index and its components")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Appendix3#fig_145",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("145.")]), _vm._v(" Comparative Development")]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb0cb368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Illustrations.vue
// module id = 81
// module chunks = 0